import { useGetLaunchedWorkflowsQuery, useSynchronizeFlowMutation } from '../../../../app/apiSlice';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setToast } from '../../../../app/appSlice';
import { useState } from 'react';
import "./LaunchedFlows.scss";

export const LaunchedFlows = ({ topologyID, topologyVersion }: { topologyID: string, topologyVersion: string }) => {
    const { data, refetch, ...status } = useGetLaunchedWorkflowsQuery({ topologyID });
    const [synchronizeFlow] = useSynchronizeFlowMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [syncing, setSyncing] = useState(false);

    const onSynchronizeClick = async () => {
        setSyncing(true);
        let success = true;

        try {
            await synchronizeFlow({ topoid: topologyID }).unwrap();
        } catch {
            success = false;
        }

        try {
            await refetch();
        } catch {
            success = false;
        }

        setSyncing(false);

        if (success) {
            dispatch(setToast({ severity: "success", content: "Synchronisation des flux réussie", life: 3000 }));
        } else {
            dispatch(setToast({ severity: "error", content: "Echec de la synchronisation des flux", life: 5000 }));
        }
    };

    return (
        <div className="launched-flows">
            <div className="title-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h1 style={{ margin: 0 }}>Liste des flux lancés</h1>
                <Button
                    icon="pi pi-refresh"
                    className="p-button-text p-button-sm"
                    onClick={onSynchronizeClick}
                    loading={syncing}
                    tooltip="Resynchroniser les flux"
                    tooltipOptions={{ position: 'top' }}
                    aria-label="Resynchroniser les flux"
                />
            </div>

            {status.isError ? (
                <span>Erreur de récupération des flux</span>
            ) : status.isLoading ? (
                <ProgressSpinner />
            ) : data && data.length > 0 ? (
                <ul>
                    {data.map((flow: any) => (
                        <li key={flow.name}>
                            <span
                                onClick={() =>
                                    navigate(`/workflow`, {
                                        state: { topologyID, topologyVersion, flowID: flow.name },
                                    })
                                }
                            >
                                {flow.name}
                            </span>
                        </li>
                    ))}
                </ul>
            ) : (
                <span>Pas de flux lancés</span>
            )}
        </div>
    );
};
